import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { ServiceProviderContext } from "./ServiceProviderContext";
/**
 * Create a HOC that injects services into props via the mapToServices function from a scope under the ServiceProviderContext's provider.
 *
 * This has been designed to feel similar to Redux's connect() HOC.
 * @param Container
 * @param props
 */
export function withServiceProps(mapToServices) {
    var wrapper = function (Component) {
        var WithServiceProps = /** @class */ (function (_super) {
            __extends(WithServiceProps, _super);
            function WithServiceProps() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WithServiceProps.prototype.render = function () {
                var serviceProvider = this.context;
                if (!serviceProvider) {
                    throw 'You must include a parent <ServiceProviderContext.Provider> in your component tree to use the withServiceProps HOC or useServices() hook.';
                }
                // Each injection takes place as a seperate scope.
                var scope = serviceProvider.createScope();
                // Call the mapToServices method to map the service to the props.
                var injected = mapToServices(scope.services());
                var rest = __rest(this.props, []);
                return (React.createElement(Component, __assign({}, injected, rest)));
            };
            WithServiceProps.displayName = "withServiceProps(" + getDisplayName(Component) + ")";
            return WithServiceProps;
        }(React.Component));
        ;
        WithServiceProps.contextType = ServiceProviderContext;
        return WithServiceProps;
    };
    return wrapper;
}
/**
 * Returns the display name of React component.
 * @param Component
 */
function getDisplayName(Component) {
    return (Component.displayName ||
        Component.name ||
        (typeof Component === 'string' && Component.length > 0
            ? Component
            : 'Unknown'));
}
//# sourceMappingURL=withServiceProps.js.map